module.exports = __webpack_public_path__ + "static/media/a1961f748195a33a8c04977a300ba366.98302a7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/a1961f748195a33a8c04977a300ba366.jpg
// module id = 301
// module chunks = 0